import { textPackage } from '@utils/wm-functions'
import i18n from '@whatsmenu/i18n'
import { DateTime } from 'luxon'
import { useSession } from 'next-auth/react'
import Queue from 'queue'
import { useContext, useEffect, useRef, useState } from 'react'
import { Button, Col, Form, Modal, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { IReactToPrintProps, useReactToPrint } from 'react-to-print'
import { api } from 'src/lib/axios'
import { AppContext } from '../../../context/app.ctx'
import { CartsContext } from '../../../context/cart.ctx'
import { TableContext } from '../../../context/table.ctx'
import useWebPrint from '../../../hooks/useWebPrint'
import { setCartsAction } from '../../../reducers/carts/actions'
import Cart from '../../../types/cart'
import { SendStatusMessageForm } from '../../SendStatusMessageForm'
import { EditCartModal } from '../EditCartModal'
import { PackageAlterDate } from '../Requests/Package/AlterDate'
import { NotePrint, NotePrintProps } from '@whatsmenu/print-component'
import { TablePrinter } from './TablePrint'
import { TextOnly } from './TextOnly'
// import { NineNineOrderCancelModal } from '@components/Modals/NineNine/nine-nine-order-cancel'

export function PrinterRequests() {
  const { t } = useTranslation()
  const { possibleMobile } = useContext(AppContext)
  const {
    carts,
    showLostRequestsModal,
    setShowLostRequestsModal,
    motoboys,
    setCart,
    updateMotoboyId,
    cartEvents,
    setCarts,
    createOrderAgilizone,
    createOrderEntregasExpressas,
  } = useContext(CartsContext)
  const { data: session } = useSession()
  const [cartsNotPrinted, setCartsNotPrinted] = useState<Cart[]>([])
  const [showRemoveItemModal, setShowRemoveItemModal] = useState(false)

  const {
    setRequestsToPrint,
    handleShowToast,
    profile,
    handleConfirmModal,
    audio,
    wsPrint,
    requestsToPrint,
    setPrintStart,
    door,
    setDoor,
  } = useContext(AppContext)
  const { tablesFetched, tables, updateTableBeforeClose } =
    useContext(TableContext)
  const {
    carts: cartsToPrint,
    profileOptions,
    type,
    onHide,
    report,
    titleTable,
    printerTest,
    printerCenter,
    wsPrinting,
    onFinished,
    table,
    isNfce,
    command,
    automatic,
  } = requestsToPrint
  const waitMillis = localStorage.getItem('waitMillis')
    ? Number(localStorage.getItem('waitMillis'))
    : 5000

  const [showAlterDateModal, setShowAlterDateModal] = useState<boolean>(false)
  const [printQueueActive, setPrintQueueActive] = useState(false)
  const [alreadyPrintedLostRequests, setAlreadyPrintedLostRequests] =
    useState(false)
  const [detaildTable, setDetaildTable] = useState(false)

  // const componentRef = useRef<HTMLTableElement>(null);
  const componentRef = useRef<HTMLPreElement>(null)

  const [optionDelivery, setOptionDelivery] = useState<Date | null>(null)
  const [modalCancelDeliveryMottu, setModalCancelDeliveryMottu] =
    useState(false)
  const [taxmessageCancelMottu, setTaxmessageCancelMottu] = useState(false)
  const [selectedOption, setSelectedOption] = useState('')

  const clearAppRequests = () => {
    setRequestsToPrint({ carts: [] })
  }

  const normalizePrintText = (text?: string) => {
    if (!text) {
      return ''
    }

    return text
      .replaceAll('\u00A0', ' ')
      .replace(/\n{2,}/g, '\n')
      .replace(/:\n(?!\n)/g, ': ')
      .replace(/\n(\([^)]+\))/g, ' $1')
      .replace(/(\d+X \| .+)/g, '$1\n')
  }

  const copies =
    report || 'isElectron' in window
      ? 1
      : (profileOptions ?? profile.options)?.print.copies
  const copiesTimes = Array(copies > 100 || copies < 0 ? 1 : copies).fill('.')
  const CompTablePrint: any = (profileOptions ?? profile.options)?.print
    .textOnly
    ? TextOnly
    : TablePrinter

  const { printBluetooth, printUsb } = useWebPrint()
  const profileHasAgilizone = profile?.options?.integrations?.agilizone
  const profileHasEntregasexpressas =
    profile?.options?.integrations?.entregasexpressas

  const markCartsAsPrinted = async (cartsBatch: Cart[]) => {
    if (!session || cartsBatch.length === 0) {
      return
    }

    await Promise.all(
      cartsBatch.map(async (cart) => {
        await cart.setPrinted(session)
        cart.print = 1
      })
    )

    setCarts([...carts])
  }

  const markCartAsPrinted = async (cart: Cart) => {
    if (!session) {
      return
    }
    await cart.setPrinted(session)
    cart.print = 1

    setCarts([...carts])
  }

  const handleClose = () => {
    onHide && onHide(carts[0])
    setCart(carts[0])
    setRequestsToPrint({
      carts: [],
      show: false,
      command: null,
    })
  }

  const handleEditCart = () => {
    const cartCode = cartsToPrint[0].code
    window.DesktopApi?.editCart(cartCode)
  }

  let timeout: NodeJS.Timeout
  const printConfig: IReactToPrintProps = {
    content: () => componentRef.current,
    onBeforeGetContent: () => {
      console.log((profileOptions ?? profile.options)?.print.width, {
        cartCode: cartsToPrint[0].code,
      })
      if (componentRef.current) {
        // console.log(componentRef.current?.innerText)
      }
    },
    onPrintError: (_, err) => {
      setPrintStart(false)
      setDoor((door) => true)
      console.error('Erro na impressão.', err)
    },
    documentTitle: profile.name,
    copyStyles: false,
    pageStyle: `
    * {
      padding: 0;
      margin: 0;
    }
    *.text-only,
    *.title {
      display: inherit !important;
      white-space: normal !important;
    }

    *.formated {
      white-space: pre-line !important;
      font-size: ${(profileOptions ?? profile.options)?.print.fontSize === 7 ? '14pt' : '18pt'};
    }

    .formated.print-title {
      font-size: 1.75rem !important;
      font-weight: bolder;
      text-align: center;
    }

    .observation-space {
      max-width: 90% !important;
      padding-left: 5mm !important;
      word-break: break-all !important;
      white-space: normal !important;
    }

    .longText {
    font-weight: bold;
      font-size:${(profileOptions ?? profile.options)?.print.width === '302px' ? 16 : 5}px !important;
    }

    .formated.print-row div {
      display: flex;
      width: ${(profileOptions ?? profile.options)?.print.width === '302px' ? 100 : 65}mm !important;
      overflow: hidden;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    .formated.print-row div p {
      &.complement-space {
        padding-left: ${(profileOptions ?? profile.options)?.print.width === '302px' ? 13 : 4}mm !important;
      }

      &.item-space {
        padding-left: ${(profileOptions ?? profile.options)?.print.width === '302px' ? 20 : 8}mm !important;
      }

      &.transshipment-space {
        padding-left: ${(profileOptions ?? profile.options)?.print.width === '302px' ? 9 : 5}mm !important;
      }
    }
      `,
    onBeforePrint() {
      timeout = setTimeout(() => {
        setDoor((old) => true)
        // void markCartsAsPrinted(cartsToPrint)
        void markCartAsPrinted(cartsToPrint[0])
        sessionStorage.removeItem('printedQueue')
      }, 5000)
    },
    onAfterPrint() {
      const copies = possibleMobile
        ? report || 'isElectron' in window
          ? 1
          : (profileOptions ?? profile.options)?.print.copies
        : Number(sessionStorage.getItem(`${cartsToPrint[0].id}_copies`) ?? 1)

      if (
        copies ===
        (report || 'isElectron' in window
          ? 1
          : (profileOptions ?? profile.options)?.print.copies)
      ) {
        onFinished && onFinished()
      }

      if (
        copies <
          (report || 'isElectron' in window
            ? 1
            : (profileOptions ?? profile.options)?.print.copies) &&
        cartsToPrint[0]
      ) {
        sessionStorage.setItem(`${cartsToPrint[0].id}_copies`, `${copies + 1}`)
        if (audio && wsPrinting) {
          handlePrint()
          if (profile.options.playSoundDelivery) {
            audio?.load()
            audio?.play().catch(() => {
              console.error('Não foi possível enviar a cópia para impressão.')
              handlePrint()
            })
          }
        } else {
          handlePrint()
        }
      } else {
        sessionStorage.removeItem(`${cartsToPrint[0].id}_copies`)
        try {
          if (cartsToPrint[0] && session) {
            const confirmPrint = async () => {
              // await markCartsAsPrinted(cartsToPrint)
              await markCartAsPrinted(cartsToPrint[0])
            }
            confirmPrint()
            if (wsPrinting) {
              setCartsNotPrinted((state) => {
                const newArray = state.filter((cart, index) => index !== 0)
                return [...newArray]
              })
            }
          }

          setTimeout(() => {
            if (audio) {
              audio.onended = null
            }
            if (!possibleMobile) {
              clearTimeout(timeout)
              setDoor(true)
            }
          }, 20)
        } catch (error) {
          console.error(error)

          cartsToPrint[0].print = 0
          setPrintStart(false)
          setDoor(true)

          handleShowToast({
            type: 'erro',
            title: 'Confirmação de pedido',
            content:
              'Não foi possivel realizar a confirmação de impressão do pedido',
          })
        } finally {
          setRequestsToPrint({ carts: [] })
          sessionStorage.removeItem(`printedQueue`)
        }
      }
    },
  }

  if (
    (profileOptions ?? profile.options)?.print?.web &&
    (profileOptions ?? profile.options)?.print?.web !== ''
  ) {
    // let dataToPrint = componentRef.current?.innerText
    printConfig.print = async () => {
      if (componentRef.current?.innerText) {
        const textToPrint = normalizePrintText(componentRef.current.innerText)
        ;(profileOptions ?? profile.options)?.print?.web === 'bluetooth'
          ? await printBluetooth(textToPrint)
          : await printUsb(textToPrint)
      }
    }
  }

  const printQueue = new Queue({
    concurrency: 1,
    autostart: true,
  })

  if ('isElectron' in window) {
    const prunedProfile = {
      name: profile?.name,
      typeDelivery: profile?.typeDelivery,
      taxDelivery: profile?.taxDelivery,
      timezone: profile?.timeZone,
      options: {
        locale: profile?.options?.locale,
        print: {
          ...profile?.options?.print,
          copies: 1,
        },
        pizza: profile?.options?.pizza,
        package: profile?.options?.package,
      },
    }

    printConfig.print = async (target) => {
      delete cartsToPrint[0].command?.opened?.table?.opened
      if ('WhatsMenuPrintApi' in window) {
        const printerAvailability =
          typeof (window.WhatsMenuPrintApi as any).checkPrinter === 'function'
            ? await (window.WhatsMenuPrintApi as any).checkPrinter()
            : true
        console.log('printerAvailability', printerAvailability)

        printQueue.push(async () => {
          if (printerAvailability) {
            await (window.WhatsMenuPrintApi as any).print(
              JSON.stringify({
                cart: {
                  ...cartsToPrint[0],
                  motoboy: motoboys.find(
                    (motoboy) => motoboy.id === cartsToPrint[0].motoboyId
                  ),
                },
                automatic,
                profile: prunedProfile,
                table,
                printType:
                  type === 'command' || type === 'table' ? type : undefined,
              })
            )
          }
        })
      }
    }
  }

  const handlePrint = useReactToPrint(printConfig)

  const $alterDateModal = (cart: Cart) => {
    return (
      <PackageAlterDate
        show={showAlterDateModal}
        cart={cart}
        onHide={() => {
          setShowAlterDateModal(false)
        }}
      />
    )
  }

  const $btnAlterDate = (
    <Button
      variant="outline-dark"
      className=" fs-7 w-100 mt-1"
      disabled={cartsToPrint[0]?.status === 'canceled'}
      onClick={() => {
        // requestsToPrint.onHide();
        setShowAlterDateModal(true)
      }}
    >
      {/* <CgArrowsExchangeAlt size={20} /> */}
      <span className="align-middle">Alterar Data</span>
    </Button>
  )

  const pushToPrint = async () => {
    if ((profileOptions ?? profile.options)?.print.app) {
      const textToPrint = normalizePrintText(componentRef.current?.innerText)
      if ('ReactNativeWebView' in window) {
        ;(window as any).ReactNativeWebView.postMessage(
          JSON.stringify({
            event: 'directPrint',
            data: {
              58: textToPrint,
              80: textToPrint,
              requestId: cartsToPrint[0].id,
            },
          })
        )
      } else {
        wsPrint.wsEmit('directPrint', {
          58: textToPrint,
          80: textToPrint,
          requestId: cartsToPrint[0].id,
        })
      }
      // handlePrintApp(
      //   clearAppRequests,
      //   wsPrint,
      //   requests,
      //   type,
      //   report,
      //   {
      //     table: requestsToPrint.table,
      //     opened: requestsToPrint.opened,
      //     command: requestsToPrint.command,
      //   }
      // )
      setDoor((door) => true)
      if (session) {
        // await markCartsAsPrinted(cartsToPrint)
        await markCartAsPrinted(cartsToPrint[0])
        setCartsAction(carts)
      }
    } else {
      handlePrint()
    }
  }

  const handleCancelRequest = async (cartId: number) => {
    try {
      const createdAt = DateTime.fromISO(
        cartsToPrint[0].controls.grovenfe?.fiscal_note.created_at ?? '',
        { zone: profile.timeZone }
      )
      const now = DateTime.now()
      const diffInMinutes = now.diff(createdAt, 'minutes').minutes
      if (
        diffInMinutes > 30 ||
        !cartsToPrint[0].controls.grovenfe?.fiscal_note
      ) {
        return console.error('Nenhuma nota fiscal encontrada')
      }
      await api.patch(`/dashboard/carts/${cartId}/cancel/nfce`)
    } catch (error) {
      console.error(error)
    }
  }

  const printApp = (profileOptions ?? profile.options)?.print.app
  // //Verificação se o modal esta aberto e fecha para o pedido que chegou ser impresso
  useEffect(() => {
    if (
      !printApp &&
      door &&
      requestsToPrint.show &&
      cartsNotPrinted.length &&
      !wsPrinting
    ) {
      setRequestsToPrint({ carts: [] })
    }
  }, [
    printApp,
    door,
    cartsNotPrinted,
    requestsToPrint,
    carts,
    setRequestsToPrint,
    wsPrinting,
  ])

  useEffect(() => {
    const cartsWithPrintZero = carts
      .filter((cart) => !cart.print)
      .sort((cartA, cartB) => Number(cartA.code) - Number(cartB.code))
    setCartsNotPrinted(cartsWithPrintZero)
  }, [carts, setCartsNotPrinted])

  //Filtro de requests que não foram impressos
  // useEffect(() => {
  //   if (door && !profile?.options?.print?.app) {
  //     console.log("Procurando por pedidos não impressos.");
  //     setCartsNotPrinted(state => {
  //       if (!state.length) {
  //         state.sort((cartA, cartB) => Number(cartA.code) - Number(cartB.code));
  //         const toPrint = state;
  //         carts.forEach(cart => {
  //           const exists = toPrint.find(r => r.id === cart.id);
  //           if (!exists && !cart.print && cart.status !== 'canceled') {
  //             !possibleMobile && (cart.print = 1);
  //             toPrint.push(cart);
  //           }
  //         });
  //         toPrint.sort((cartA, cartB) => Number(cartA.code) - Number(cartB.code));

  //         if (state.length) {
  //           setRequestsToPrint({ carts: [] });
  //           return compareItems(toPrint, carts) ? [...state] : [...toPrint];
  //         }

  //         return state;
  //       }

  //       return state
  //     })
  //   }

  // }, [carts, door, setCartsNotPrinted, setRequestsToPrint]);

  useEffect(() => {
    //Remove printQueue sessionStorage
    if (
      door &&
      (!cartsNotPrinted.length || (!carts.length && !cartsNotPrinted.length))
    ) {
      sessionStorage.removeItem('printedQueue')
    }

    //Requests que ainda não foram impressos
    const requestsTable = cartsNotPrinted.some((req) => req.type === 'T')

    if (
      (tablesFetched && requestsTable ? tablesFetched : true) &&
      door &&
      cartsNotPrinted.length &&
      !cartsToPrint.length
    ) {
      const nextRequestsToPrint = cartsNotPrinted.map((cart) => {
        let tableToPrint = cart.command?.opened?.table
        if (tableToPrint) {
          tableToPrint.opened = cart.command?.opened
        }
        if (!tableToPrint && cart.type === 'T') {
          updateTableBeforeClose()
            .then((result) => {
              tableToPrint = result
            })
            .catch((err) => console.error(err))
        }
        return {
          automatic: true,
          carts: [cart],
          directPrint: true,
          wsPrinting: true,
          appPrint: profile.options.print.app,
          type: cart.type,
          table: tableToPrint,
        }
      })

      if (nextRequestsToPrint.length) {
        if (
          nextRequestsToPrint.length > 3 &&
          !printQueueActive &&
          !alreadyPrintedLostRequests &&
          showLostRequestsModal
        ) {
          setShowLostRequestsModal((showLostState) => {
            if (showLostState) {
              setDoor(false)
              handleConfirmModal({
                show: true,
                title: 'Impressões Pendentes',
                message: `Há ${cartsNotPrinted.length} pedidos pendentes para impressão, deseja realizar a impressão destes pedidos?`,
                confirmButton: 'Imprimir todos',
                actionConfirm: async () => {
                  setPrintQueueActive(true)
                  if (profile.options.playSoundDelivery) {
                    audio?.play().catch(() => {
                      console.error('Não foi possível reproduzir o som.')
                    })
                  }
                  setRequestsToPrint({
                    automatic: true,
                    carts: [...cartsNotPrinted],
                    directPrint: true,
                    wsPrinting: true,
                    appPrint: profile.options.print.app,
                    type: cartsNotPrinted[0]?.type,
                    table: cartsNotPrinted[0]?.command?.opened?.table,
                  })
                  setDoor(true)
                  setAlreadyPrintedLostRequests(true)
                },
                actionCancel: async () => {
                  if (session) {
                    for (const cart of cartsNotPrinted) {
                      await cart.setPrinted(session)
                    }

                    setCartsNotPrinted([])
                  }
                  setDoor(true)
                  setAlreadyPrintedLostRequests(true)
                },
              })
            }

            return false
          })
        } else {
          if (
            cartsNotPrinted.some(
              (cart) => cart.status !== 'canceled' && !profile.options.print.app
            )
          ) {
            nextRequestsToPrint.forEach((cartToPrint) => {
              switch (cartToPrint.type) {
                case 'D':
                  if (profile.options.playSoundDelivery) {
                    audio?.play().catch(() => {
                      console.error('Não foi possível reproduzir o som.')
                    })
                  }
                  break
                case 'T':
                  if (profile.options.playSoundPdv) {
                    audio?.play().catch(() => {
                      console.error('Não foi possível reproduzir o som.')
                    })
                  }
                  break
                case 'P':
                  if (profile.options.playSoundPackage) {
                    audio?.play().catch(() => {
                      console.error('Não foi possível reproduzir o som.')
                    })
                  }
                  break
                default:
                  if (profile.options.playSoundDelivery) {
                    audio?.play().catch(() => {
                      console.error('Não foi possível reproduzir o som.')
                    })
                  }
                  break
              }
            })
          }
          setRequestsToPrint(nextRequestsToPrint[0])
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [door, cartsNotPrinted, cartsToPrint, setRequestsToPrint, tablesFetched])

  const cancelRequestButton = (
    <SendStatusMessageForm
      profileOptions={profileOptions}
      taxmessageCancelMottu
      cart={cartsToPrint[0]}
      newStatus={cartsToPrint[0]?.status === 'canceled' ? null : 'canceled'}
      button={{
        name:
          cartsToPrint[0]?.status === 'canceled'
            ? 'Descancelar Pedido'
            : 'Cancelar Pedido',
        props: {
          variant:
            cartsToPrint[0]?.status === 'canceled' ? 'primary' : 'danger',
          className: 'fs-7 w-100 text-nowrap',
          disabled: false,
        },
      }}
    />
  )

  useEffect(() => {
    if (requestsToPrint.directPrint) {
      setDoor(false)
      handlePrint()
    } else if (requestsToPrint.automatic) {
      if (!(profileOptions ?? profile.options).print.app) {
        if (timeout) {
          clearTimeout(timeout)
        }
        setDoor(false)
        handlePrint()
      } else if (!wsPrinting) {
        pushToPrint()
      }
    }
  }, [requestsToPrint])

  const [blobUrlPrint, setBlobUrlPrint] = useState('')

  const sendGroupCartForMottu = async (cartMottu: Cart[]) => {
    const cartsIds = cartMottu.map((cartSelected) => cartSelected.id)
    try {
      const { data } = await api.post('/dashboard/mottu/create', { cartsIds })
      if (cartsToPrint[0].controls) {
        cartsToPrint[0].controls.mottu = data.carts[0].controls?.mottu
      }
      setSelectedOption('mottu')
      handleShowToast({
        type: 'success',
        content: 'Entrega criada com sucesso',
        title: 'Entrega',
      })
    } catch (error) {
      handleShowToast({
        type: 'erro',
        content: 'Falha ao criar entrega',
        title: 'Entrega',
      })
      setSelectedOption('')
      throw new Error('Não foi possível enviar pedido para Mottu')
    }
  }

  const selectedDeliveryOption = ({
    targetValue,
    cart,
  }: {
    targetValue: string
    cart: Cart
  }) => {
    const hournow = DateTime.now()

    if (targetValue === 'mottu') {
      sendGroupCartForMottu([cart])
      setSelectedOption(targetValue)
    }
    if (targetValue !== 'mottu' && !cart.controls?.mottu?.orderId) {
      cartsToPrint[0].setMotoboyId(parseInt(targetValue), () => {
        setCart(cartsToPrint[0])
        if (session) {
          updateMotoboyId(
            cartsToPrint[0].id,
            cartsToPrint[0].origin as string,
            parseInt(targetValue),
            session
          )
        }
      })
    }
    if (targetValue !== 'mottu' && cart.controls?.mottu?.orderId) {
      const orderMottuData = DateTime.fromISO(
        String(cart.controls?.mottu.orderCreated_at)
      )
      const diffInMinutes = hournow.diff(orderMottuData, 'minutes').minutes
      console.log({ diffInMinutes, hournow })
      if (diffInMinutes > 5) {
        setTaxmessageCancelMottu(true)
      } else {
        setTaxmessageCancelMottu(false)
      }
      setModalCancelDeliveryMottu(true)
    }
  }

  return (
    <>
      {requestsToPrint.directPrint ? (
        <div
          className="table-container"
          style={{
            position: 'fixed',
            overflow: 'hidden',
            zIndex: -99999,
            left: '-99999px',
            top: '0',
          }}
        >
          <NotePrint
            ref={componentRef}
            profile={{ ...profile, options: profileOptions ?? profile.options }}
            cart={cartsToPrint[0]}
            carts={cartsToPrint}
            report={report}
            table={table}
            command={command ?? undefined}
            printType={type as NotePrintProps['printType']}
            detailedTable={requestsToPrint.detaildTable ?? detaildTable}
            motoboys={motoboys}
            textPackage={textPackage(profile?.options?.package.label2)}
          />
          {/* <CompTablePrint
            cart={cartsToPrint[0]}
            carts={cartsToPrint}
            copiesTimes={copiesTimes}
            componentRef={componentRef}
            classBold={
              (profileOptions ?? profile.options)?.print.bolder ?? true
                ? "fw-bold"
                : ""
            }
            fontSize={
              (profileOptions ?? profile.options)?.print.fontSize ?? 7
            }
            margin={(profileOptions ?? profile.options)?.print.margin ?? 0}
            paperSize={
              (profileOptions ?? profile.options)?.print.width === "302px"
                ? 72
                : 58
            }
            groupItems={
              (profileOptions ?? profile.options)?.print.groupItems ?? false
            }
            type={type}
            report={report}
            table={requestsToPrint.table}
            opened={requestsToPrint.table?.opened}
            command={requestsToPrint.command !== undefined ? requestsToPrint.command : null}
            autoPrint={() => {
              if(!profile.options.print.active) {
                return
              }
              if (!(profileOptions ?? profile.options).print.app) {
                if (timeout) {
                  clearTimeout(timeout);
                }
                setDoor(false);
                handlePrint();
              } else if (!wsPrinting) {
                pushToPrint();
              }
            }}
            titleTable={titleTable}
            wsPrinting={wsPrinting}
          /> */}
        </div>
      ) : (
        <div
          onClick={(e) => {
            if (
              e.target instanceof HTMLElement &&
              (e.target as HTMLElement).className.includes('fade modal show')
            ) {
              handleClose()
            }
          }}
        >
          <Modal
            show={!!requestsToPrint?.carts?.length && requestsToPrint.show}
            size="lg"
            scrollable
            // backdrop="static"
            keyboard={false}
            centered
            // backdropClassName="close-modal-backdrop"
            style={{ zIndex: 99999 }}
            onHide={handleClose}
          >
            <Modal.Header
              className="justify-content-between align-items-center  "
              closeButton
            >
              <div className="d-flex flex-column align-items-center ms-auto">
                <h4 className="fw-bold mb-0">
                  {report
                    ? 'Pedido de Relatório'
                    : printerTest
                      ? 'Pedido para Teste de Impressão'
                      : isNfce
                        ? 'Pré Visualização da NFCE'
                        : 'Pré Visualização do Pedido'}
                </h4>
                {cartsToPrint?.[0]?.address &&
                  !cartsToPrint?.[0]?.address?.latitude &&
                  !cartsToPrint?.[0]?.address?.longitude && (
                    <span className="text-danger small fw-bold">
                      *Endereço sem coordenadas
                    </span>
                  )}
              </div>
            </Modal.Header>
            <Modal.Body className="p-0" style={{ overflowX: 'hidden' }}>
              <Row>
                <Col
                  sm={report || printerCenter ? '12' : '8'}
                  className={
                    isNfce
                      ? 'd-flex justify-content-center w-100'
                      : 'd-flex justify-content-center'
                  }
                >
                  <div
                    className="border-start border-end border-dark overflow-auto py-3"
                    style={{
                      width: 'auto',
                      padding: '0 1rem',
                      minHeight: '70vh',
                      maxHeight: '70vh',
                    }}
                  >
                    <div className="d-flex justify-content-center">
                      <NotePrint
                        ref={componentRef}
                        profile={{
                          ...profile,
                          options: profileOptions ?? profile.options,
                        }}
                        cart={cartsToPrint[0]}
                        carts={cartsToPrint}
                        report={report}
                        table={table}
                        printType={type as NotePrintProps['printType']}
                        command={command ?? undefined}
                        detailedTable={
                          requestsToPrint.detaildTable ?? detaildTable
                        }
                        motoboys={motoboys}
                        textPackage={textPackage(
                          profile?.options?.package.label2
                        )}
                      />
                    </div>

                    {/* <div>
                      <CompTablePrint
                        carts={cartsToPrint}
                        copiesTimes={copiesTimes}
                        componentRef={componentRef}
                        classBold={
                          (profileOptions ?? profile.options)?.print.bolder ??
                            true
                            ? "fw-bold"
                            : ""
                        }
                        fontSize={
                          (profileOptions ?? profile.options)?.print
                            .fontSize ?? 7
                        }
                        margin={
                          (profileOptions ?? profile.options)?.print.margin ??
                          0
                        }
                        paperSize={
                          (profileOptions ?? profile.options)?.print.width ===
                            "302px"
                            ? 72
                            : 58
                        }
                        groupItems={
                          (profileOptions ?? profile.options)?.print
                            .groupItems ?? false
                        }
                        type={type}
                        report={report}
                        table={requestsToPrint.table}
                        opened={requestsToPrint.opened}
                        command={requestsToPrint.command !== undefined ? requestsToPrint.command : null}
                        titleTable={titleTable}
                      />
                    </div> */}
                  </div>
                </Col>
                {!isNfce && (
                  <>
                    {!report && !printerCenter && (
                      <Col
                        sm="4"
                        className="border-start d-flex flex-column justify-content-center align-items-center"
                      >
                        <Row className="w-100 mx-auto mt-2">
                          <Col className="d-flex flex-column gap-2">
                            {cartsToPrint[0] &&
                              !report &&
                              type !== 'table' &&
                              type !== 'command' && (
                                <>
                                  <SendStatusMessageForm
                                    profileOptions={profileOptions}
                                    cart={cartsToPrint[0]}
                                    newStatus="production"
                                    button={{
                                      name:
                                        cartsToPrint[0].type === 'T' ||
                                        cartsToPrint[0].origin === 'ifood'
                                          ? `${i18n.t('preparation')}`
                                          : `${i18n.t('received')}`,
                                      props: {
                                        variant:
                                          cartsToPrint[0].status !== null
                                            ? 'outline-primary'
                                            : 'primary',
                                        className: 'fs-7',
                                        disabled:
                                          cartsToPrint[0]?.status ===
                                            'canceled' ||
                                          cartsToPrint[0]?.status ===
                                            'delivered',
                                      },
                                    }}
                                  />
                                  <SendStatusMessageForm
                                    profileOptions={profileOptions}
                                    cart={cartsToPrint[0]}
                                    newStatus="transport"
                                    button={{
                                      name: !cartsToPrint[0].addressId
                                        ? `${i18n.t('ready_for_pickup')}`
                                        : cartsToPrint[0].type !== 'T'
                                          ? `${i18n.t('delivering')}`
                                          : '',
                                      props: {
                                        variant:
                                          cartsToPrint[0].status ===
                                            'transport' ||
                                          cartsToPrint[0].status === 'delivered'
                                            ? 'outline-orange'
                                            : 'orange',
                                        className: 'fs-7 persist-outline',
                                        disabled:
                                          cartsToPrint[0]?.status ===
                                          'canceled',
                                      },
                                    }}
                                  />
                                  <SendStatusMessageForm
                                    cart={cartsToPrint[0]}
                                    newStatus="delivered"
                                    button={{
                                      name:
                                        cartsToPrint[0].type === 'T' ||
                                        cartsToPrint[0].origin === 'ifood'
                                          ? `${i18n.t('finished')}`
                                          : `${i18n.t('finished')}`,
                                      props: {
                                        variant:
                                          cartsToPrint[0].status === 'delivered'
                                            ? 'outline-success'
                                            : 'success',
                                        className: 'fs-7 persist-outline',
                                        disabled:
                                          cartsToPrint[0]?.status ===
                                          'canceled',
                                      },
                                    }}
                                  />
                                </>
                              )}
                            {cartsToPrint[0] &&
                              cartsToPrint[0].type !== 'T' && (
                                <>
                                  {window.innerWidth > 768 &&
                                    !report &&
                                    cancelRequestButton}
                                  {(type === 'D' || type === 'P') &&
                                    cartsToPrint[0].origin === 'whatsmenu' && (
                                      <SendStatusMessageForm
                                        profileOptions={profileOptions}
                                        cart={cartsToPrint[0]}
                                        button={{
                                          name: 'Falar com Cliente',
                                          props: {
                                            variant: 'warning',
                                            className: 'fs-7',
                                          },
                                        }}
                                      />
                                    )}
                                </>
                              )}
                            {cartsToPrint[0]?.addressId &&
                              cartsToPrint[0]?.type !== 'T' && (
                                <Form.Select
                                  disabled={Boolean(
                                    cartsToPrint[0]?.controls.agilizone ||
                                    cartsToPrint[0]?.controls.entregas_expressas
                                  )}
                                  defaultValue={
                                    cartsToPrint[0]?.controls.agilizone
                                      ? 'agilizone'
                                      : cartsToPrint[0]?.motoboyId
                                  }
                                  onChange={(e) => {
                                    if (e.target.value === 'agilizone') {
                                      createOrderAgilizone({
                                        cart: cartsToPrint[0],
                                      })
                                      return
                                    }
                                    if (
                                      e.target.value === 'entregasexpressas'
                                    ) {
                                      try {
                                        createOrderEntregasExpressas({
                                          cart: cartsToPrint[0],
                                        })
                                      } catch (error) {
                                        console.error(error)
                                        handleShowToast({
                                          type: 'erro',
                                          title: 'Entregas Expressas',
                                          content:
                                            'Não foi possível criar a entrega na Entregas Expressas',
                                        })
                                      }
                                      return
                                    }
                                    cartsToPrint[0].setMotoboyId(
                                      parseInt(e.target.value),
                                      () => {
                                        setCart(cartsToPrint[0])
                                        if (session) {
                                          updateMotoboyId(
                                            cartsToPrint[0].id,
                                            cartsToPrint[0].origin as string,
                                            parseInt(e.target.value),
                                            session
                                          )
                                        }
                                      }
                                    )
                                  }}
                                >
                                  <option>Selecione</option>
                                  {profileHasAgilizone &&
                                    cartsToPrint[0].address.latitude &&
                                    cartsToPrint[0].address.longitude && (
                                      <option value="agilizone">
                                        Agilizone
                                      </option>
                                    )}
                                  {profileHasEntregasexpressas && (
                                    <option value="entregasexpressas">
                                      Entregas Expressas
                                    </option>
                                  )}
                                  {motoboys
                                    .filter((motoboy) => !motoboy.deleted_at)
                                    .map(
                                      (motoboy) =>
                                        motoboy.status && (
                                          <option
                                            key={motoboy.id}
                                            value={motoboy.id}
                                          >
                                            {motoboy.name}
                                          </option>
                                        )
                                    )}
                                </Form.Select>
                              )}
                          </Col>
                        </Row>
                        {cartsToPrint[0]?.origin === 'whatsmenu' && (
                          <Row className="w-100 mx-auto mt-5">
                            <Col className="d-flex flex-column gap-2">
                              <Button
                                disabled={
                                  cartsToPrint[0]?.status === 'delivered' ||
                                  cartsToPrint[0]?.status === 'canceled' ||
                                  cartsToPrint[0]?.itens.every(
                                    (item) => item.deleted_at !== null
                                  )
                                }
                                variant="primary"
                                onClick={() => {
                                  if (cartsToPrint[0]?.type === 'T') {
                                    setShowRemoveItemModal(true)
                                    return
                                  }

                                  if ('isElectron' in window) {
                                    handleEditCart()
                                    return
                                  }

                                  window.open(
                                    `${process.env.NEXT_PUBLIC_WHATSMENU_BASE_URL}/${profile.slug}/pdv/cart/${cartsToPrint[0].code}`,
                                    '_blank'
                                  )
                                }}
                              >
                                Editar Pedido
                              </Button>
                            </Col>
                          </Row>
                        )}
                      </Col>
                    )}
                  </>
                )}
              </Row>
            </Modal.Body>
            <Modal.Footer className="py-4">
              <Row className="w-100 m-0 p-0">
                {cartsToPrint[0] && (
                  <>
                    <Col sm="4" className="px-1">
                      {window.innerWidth > 768 ? (
                        <Button
                          variant="outline-primary"
                          className=" fs-7 w-100 mt-1  text-nowrap"
                          onClick={handleClose}
                        >
                          <span className="align-middle">Fechar</span>
                        </Button>
                      ) : (
                        !report &&
                        (type === 'D' || type === 'P') &&
                        cancelRequestButton
                      )}
                    </Col>
                    <Col
                      sm="4"
                      className="d-flex align-items-center justify-content-center px-1"
                    >
                      {cartsToPrint[0].type === 'P' && !report && $btnAlterDate}
                      {report && cartsToPrint[0].type === 'T' && (
                        <Form.Switch
                          checked={detaildTable}
                          onChange={(e) => setDetaildTable(e.target.checked)}
                          className="my-auto"
                          label="Detalhar Mesa"
                          id="detailedTable"
                        />
                      )}
                    </Col>
                  </>
                )}
                {isNfce ? (
                  <>
                    <Col sm="4">
                      <Button
                        variant="danger"
                        className="fs-7 w-100 mt-1"
                        onClick={() => handleCancelRequest(cartsToPrint[0].id)}
                      >
                        Cancelar
                      </Button>
                    </Col>
                  </>
                ) : (
                  <>
                    <Col
                      sm="4"
                      className={`px-1 ${!cartsToPrint[0] ? 'ms-auto' : ''}`}
                    >
                      <Button
                        variant="outline-secondary"
                        className=" fs-7 w-100 mt-1"
                        onClick={() => {
                          pushToPrint()
                        }}
                      >
                        <span className="align-middle">Imprimir</span>
                      </Button>
                    </Col>
                  </>
                )}
              </Row>
            </Modal.Footer>
          </Modal>
          <EditCartModal
            show={showRemoveItemModal}
            cart={cartsToPrint[0]}
            onHide={() => setShowRemoveItemModal(false)}
          />
          <>{cartsToPrint[0] && $alterDateModal(cartsToPrint[0])}</>
        </div>
      )}
    </>
  )
}
